import { BASE_URL } from '../utils/consts';

// Сколько ждём ответа сервера лицензий. Обычно он отвечает за доли секунды;
// при блокировке у провайдера запрос висит без ответа, и без таймаута кнопка
// молча ничего не делает.
const CHECK_TIMEOUT_MS = 10000;

function getResponse(res) {
    if (!res.ok) {
      return Promise.reject(new Error(`HTTP ${res.status}`));
    }
    return res.json();
}

export function checkLicense(license_key) {
  const API_LOGIN = process.env.REACT_APP_API_LOGIN;
  const API_PASSWORD = process.env.REACT_APP_API_PASSWORD;

  const credentials = btoa(`${API_LOGIN}:${API_PASSWORD}`);

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS);

  return fetch(`${BASE_URL}/api/license/check`, {
    method: 'POST',
    signal: controller.signal,
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Basic ${credentials}`
    },
    body: JSON.stringify({license_key})
  })
  .then(getResponse)
  .then((data) => {
    return data
  })
  .finally(() => clearTimeout(timer))
}
